// extracted by mini-css-extract-plugin
export var actions = "_3k-0";
export var actionsContainer = "_3k-7";
export var border = "_3k-1";
export var childFullHeight = "_3k-f";
export var collapse = "_3k-2";
export var content = "_3k-a";
export var contentChild = "_3k-e";
export var fullscreen = "_3k-c";
export var hasLeftRadius = "_3k-k";
export var headerContainer = "_3k-3";
export var headerRow = "_3k-5";
export var hidePadding = "_3k-b";
export var navCollapsedGap = "_3k-l";
export var noScrollX = "_3k-m";
export var noScrollY = "_3k-n";
export var noTopPadding = "_3k-i";
export var optOutTopPadding = "_3k-d";
export var pageMain = "_3k-j";
export var pageOuter = "_3k-g";
export var pagePadding = "_3k-8";
export var pageScroll = "_3k-9";
export var profile = "_3k-o";
export var profileContainer = "_3k-p";
export var profileImage = "_3k-q";
export var profileMain = "_3k-r";
export var profileSubtitle = "_3k-t";
export var profileTitle = "_3k-s";
export var showLeftPadding = "_3k-h";
export var tabsPortalSlot = "_3k-6";
export var tabsWrapper = "_3k-4";
export var title = "_3k-u";